import styled from 'styled-components';

export const StyledTable = styled.table`
  border-collapse: collapse;
  width: 100%;
`;

export const TH = styled.th`
  width: 20px;
  background-color: ${({ dark }) => (dark ? '#E2E2E2' : 'white')};
  @media screen and (max-width: 768px) {
    height: 80px;
  }
`;

export const TD = styled.td`
  cursor: pointer;
  text-align: center;
  background-color: ${({ odd, dark }) => {
    if (odd && dark) {
      return '#C2C2C2';
    } else if (odd && !dark) {
      return '#DFDFDF';
    } else if (!odd && dark) {
      return '#DEDEDE';
    } else {
      return '#FFFFFF';
    }
  }};
`;

export const OptionsText = styled.p`
  font-size: 13px;
  font-weight: 400;
  margin: 0 auto;
  height: 100%;

  @media screen and (max-width: 768px) {
    text-align: left;
    padding: 7px 0 0;
    writing-mode: vertical-rl;
    transform: rotate(180deg);
  }
`;

export const FirstOptionsText = styled.p`
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  margin: 6px 0;

  @media screen and (min-width: 769px) {
    font-size: 16px;
  }
`;
